import React from 'react';
import { Link } from 'react-router-dom';
import NewModules from '../Dashboard/ELearningBoard/Board/NewModules/NewModules';
import './DevAdditionalProgramsPreview.css';

const DevAdditionalProgramsPreview = () => {
    if (process.env.NODE_ENV === 'production') {
        return (
            <p style={{ padding: 24 }}>
                This preview is only available in local development.
            </p>
        );
    }

    return (
        <div className="devAdditionalProgramsPreview">
            <div className="devAdditionalProgramsPreview__banner">
                <p>
                    <strong>Dev preview</strong> — no login required. The course
                    list below uses mock data.
                </p>
                <p>
                    <Link to="/dev/additional-programs?mockCourses=1">
                        1 course
                    </Link>
                    {' · '}
                    <Link to="/dev/additional-programs?mockCourses=2">
                        2 courses (dropdown)
                    </Link>
                    {' · '}
                    <Link to="/dev/additional-programs?mockCourses=0">
                        no courses (support message)
                    </Link>
                </p>
            </div>
            <div className="devAdditionalProgramsPreview__panel">
                <h2 className="devAdditionalProgramsPreview__heading">
                    MY E-LEARNING · Additional Programs
                </h2>
                <NewModules />
            </div>
        </div>
    );
};

export default DevAdditionalProgramsPreview;
